export const pinscaleAcademyWebinarConfig = [
  { webinar1_date: '2022-03-13', cycle: 'Cycle - A0' },
];
